// export const isProdHost = true;


export const isProdHost = window.location.hostname === 'quiq.kz';

export const CAMUNDA_URL = isProdHost ? process.env.REACT_APP_CAMUNDA_PROD : process.env.REACT_APP_CAMUNDA_DEV;

export const BACKEND_URL = isProdHost ? process.env.REACT_APP_BACKEND_PROD : process.env.REACT_APP_BACKEND_DEV;

